import { IFInitWalletRsp } from "@/api/apiRsp/IFWalletRsp"
import CurrencyComponent from "@/components/currencyComponent"
import SelectUI, { SelectOption } from "@/componentsUI/Select"
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus"
import React from "react"
const Option = SelectOption

const InputWalletDropdown = (props) => {
    const { options = [] , disabled} = props

    const prefixCls = 'input-wallet-drop-down';
    const { t } = useTranslationPlus('Wallet');
    return (
        <div className={prefixCls}>
            <SelectUI
                disabled={disabled}
                value={props?.value}
                onChange={props?.onChange}
                className={`${prefixCls}-select`}
                dropdownMenuClassName={`${prefixCls}-drop-list`}
                defaultActiveFirstOption={true}
                renderFormat={(optionD: any, value: any) => {
                    const option = options?.[optionD?.['_index']]
                    return option ? (
                        <div className={`${prefixCls}-custom-render`}>
                            <CurrencyComponent
                                currencyType={option?.currencyType}
                                serverCurrencyType={option?.serverCurrencyType} />
                            <span className={`${prefixCls}-balance`}>{t('Balance')}</span>
                            <CurrencyComponent
                                amount={option?.allBalance}
                                showIcon={false}
                                showUnit={false}
                                type={'valid9'}
                                currencyType={option?.currencyType}
                                serverCurrencyType={option?.serverCurrencyType} />
                        </div>
                    ) : (
                        <div>{value}</div>
                    )
                }}
            >
                {
                    options?.map((option: IFInitWalletRsp) => (
                        <Option key={option?.currencyType} value={option?.currencyType} className={`${prefixCls}-option`}>
                            <CurrencyComponent
                                currencyType={option.currencyType}
                                serverCurrencyType={option.serverCurrencyType} />
                            <CurrencyComponent
                                amount={option?.balance}
                                showIcon={false}
                                showUnit={false}
                                type={'valid9'}
                                currencyType={option?.currencyType}
                                serverCurrencyType={option?.serverCurrencyType} />
                        </Option>
                    ))
                }
            </SelectUI>
        </div>

    )
}

export default InputWalletDropdown
